import DeviceTypesPage from './DeviceTypesPage';

export default DeviceTypesPage;
